export default __webpack_public_path__ + "static/media/starwarsapiinfowebpage.f196c375.png";